/**
 * getElement "unboxes" references to get the value they are holding *OR* returns the value if a
 * non-references is given.
 * @param maybeRef A DOM Element or a react Ref to a DOM Element
 * @returns DOM Element
 */
function getElement(maybeRef) {
  if (typeof maybeRef === 'undefined' || maybeRef === null) {
    return maybeRef;
  }
  if (maybeRef !== null && typeof maybeRef !== 'undefined' && 'current' in maybeRef) {
    return maybeRef.current;
  }
  return maybeRef;
}

export { getElement as g };
//# sourceMappingURL=getElement-87e3481d.js.map
